import BaseModelAPI from '../BaseModelAPI';

export default class StatusList extends BaseModelAPI {

	static entity = 'statuslist'
	static entityName = 'status';

	constructor() {
		this.pageIndex = 0;
		this.pageSize = 0;
		this.pageCount = 0;
		this.dataCount = 0;
	}
}
